export default __webpack_public_path__ + "static/media/REFERRALPATIENTBLANK.01df1457.png";